import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../../telemetry/utils/constants";

export function logFinishedSessionBeforeAudioTest() {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.FinishBeforeAudioTest,
    actionScenarioType: ScenarioType.DeviceTestSession,
    actionGesture: ActionGesture.Click,
    actionOutcome: PanelActionOutcome.Nav,
    moduleName: ModuleName.FinishTestButton,
    moduleSummary: ModuleSummary.FinishBeforeAudioTest,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.UserInitiated,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}
